export default function Separator(props:any){
    return <div className="w-full border-black border-b"></div>
}